/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
2/20/19
HarvestMetricsSummary: Graphs and data displayed in harvest dashboard
***********************************************************/
import React, { Component } from 'react';
import { initLineChart, initBarChart, initDoughnutChart, initBubbleChart } from '../../../../harvest_utils';
import { generateGraphDataAndLabels, generateRandomColors } from '../../../../utils';
import HarvestEmployeeTable from './harvest_employee_table';
import HarvestEquipmentTable from './harvest_equipment_table';
import { Doughnut, Line, Bar, Bubble } from 'react-chartjs-2';

class HarvestMetricsSummary extends Component {
  render() {
    let { summary, type } = this.props.query;
    let { field, block, employee, equipment } = summary;
    /* Line Chart: Lbs by field */
    let line_1 = generateGraphDataAndLabels('totalLbs', 'key', field);
    /* Line Chart: By Block */
    let line_2 = generateGraphDataAndLabels('totalLbs', 'key', block);
    /* Doughnut Chart: Cost per field */
    let doughnut_1 = generateGraphDataAndLabels('totalCost', 'key', field);
    let doughnut_colors = generateRandomColors(field);
    /* Bar Chart: Lbs by employee */
    let bar_1 = generateGraphDataAndLabels('totalLbs', 'lastName', employee);

    /* Bubble Chart: Cost by block */
    let bubble_labels_1 = employee.map((d) => d.key);
    let bubble_data_1 = employee.map((d) => { return {x: d.totalLbs, y: d.totalCost, r: Number(d.avgPerformanceIndex)*10 } });
    let bubble_title = 'WIS Lbs, Cost, & Performance Index (Scaled)';
    if (type === 'mech') {
      bubble_data_1 = employee.map((d) => { return {x: d.totalLbs, y: d.totalCost, r: d.avgDensity } });
      bubble_title = 'WIS Lbs, Cost, & Density';
    }
    return (
      <div className="row">
        <div className="col s12 m8 l8">
          <div className="card z-depth-4">
            <span className="card-title grey-text text-darken-4">Harvest Metrics</span>
            <div className="card-image">
              <Bar data={initBarChart({label: 'WIS Lbs by Employee', labels: bar_1.labels, data: bar_1.data, backgroundColor: '#3949ab',
                borderColor: '#5c6bc0 ', borderWidth: 1, hoverBackgroundColor: '#c5cae9', hoverBorderColor: '#303f9f' })}
                height={300}
                options={{
                  maintainAspectRatio: false
                }}
              />
            </div>
            <hr />
            <div className="card-content">
              <a className="btn-floating btn-move-up waves-effect waves-light red accent-2 z-depth-4 right">
                  <i className="material-icons activator">filter_list</i>
              </a>
              <div className="row">
                <div className="col s12 m6 l6">
                  <div className="linechart3">
                    <Line
                      data={initLineChart({ label: 'WIS Lbs by Block', labels: line_2.labels, data: line_2.data, backgroundColor: '#00897b' })}
                      height={250}
                      options={{
                        maintainAspectRatio: false
                      }}
                    />
                  </div>
                </div>
                <div className="col s12 m6 l6">
                  <Line
                    data={initLineChart({ label: 'WIS Lbs by Field', labels: line_1.labels, data: line_1.data, backgroundColor: '#e53935' })}
                    height={250}
                    options={{
                      maintainAspectRatio: false
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="card-reveal">
              <span className="card-title grey-text text-darken-4">Employee Metrics<i className="material-icons right">close</i></span>
              <div className="harvest-form-card">
                { type === 'hand' ? <HarvestEmployeeTable harvest={employee.sort((a,b) => a.avgPerformanceIndex > b.avgPerformanceIndex ? -1 : 1)} totals={true} type={type} />
                  : <HarvestEmployeeTable harvest={employee.sort((a,b) => Number(a.totalLbs) > Number(b.totalLbs) ? -1 : 1)} totals={true} />
                }
              </div>
              { type === 'mech' ?
                <div>
                  <br /><hr />
                  <span className="card-title grey-text text-darken-4">Equipment Metrics</span>
                  <div className="harvest-form-card">
                    <HarvestEquipmentTable harvest={equipment.sort((a,b) => Number(a.totalLbs) > Number(b.totalLbs) ? -1 : 1)} totals={true} />
                  </div>
                </div>
                : ''
              }
            </div>
          </div>
        </div>

        <div className="col s12 m4 l4 xl4">
          <div className="card z-depth-4">
            <span className="card-title grey-text text-darken-4">Cost by Field</span>
            <div className="card-image">
              <Doughnut data={initDoughnutChart({label: 'Lbs by Field', labels: doughnut_1.labels, data: doughnut_1.data, backgroundColor: doughnut_colors })}
              />
            </div>
            <hr />
            <span className="card-title grey-text text-darken-4">Cost by Employee</span>
            <div className="card-content">
              <Bubble data={initBubbleChart({ label: bubble_title, labels: bubble_labels_1, data: bubble_data_1 })}
                options={{
                  scales: {
                    yAxes: [{
                      scaleLabel: {
                        display: true,
                        labelString: '$ Cost'
                      }
                    }],
                    xAxes: [{
                      scaleLabel: {
                        display: true,
                        labelString: 'WIS Lbs'
                      }
                    }],
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default HarvestMetricsSummary;




/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/view/report/harvest_metrics_summary.jsx